import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { CreateAList } from '@thd-olt-component-react/list-forms';
import { extend } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';
import { SaveSharedListButton } from './SaveShareListButton';
import { ProductListContext } from '../ProductListContext';

export const SaveSharedList = ({ showSaveSharedListBanner }) => {
  const {
    list,
    onSaveSharedList,
    isSharedList
  } = useContext(ProductListContext);

  const fsSaveSharedList = useConfigService('fs:isSaveSharedListEnabled');

  if (!isSharedList || !fsSaveSharedList || !showSaveSharedListBanner) {
    return null;
  }

  return (
    <div className="sui-w-full sui-p-2 sui-pb-0">
      <Alert status="info">
        <Typography variant="body-base">Someone sent you this list. If you want
          to make changes to items in this list, save a copy to your lists.
        </Typography> <br />
        <Typography variant="body-base">Changes to your copy will not
          affect the sender&apos;s original list.
        </Typography> <br />
        <div className="sui-flex">
          <CreateAList
            onCreate={({ id }) => id && onSaveSharedList()}
            CustomCreateListActionElement={SaveSharedListButton}
            listId={list.id}
            isCopyList
            isSharedList
          />
        </div>
      </Alert>
    </div>
  );
};

SaveSharedList.propTypes = {
  showSaveSharedListBanner: bool
};

SaveSharedList.defaultProps = {
  showSaveSharedListBanner: false
};

SaveSharedList.displayName = 'ProductListSaveSharedList';

SaveSharedList.dataModel = extend(CreateAList);
